import { render, staticRenderFns } from "./IconEditor.vue?vue&type=template&id=3d73c6d4&"
import script from "./IconEditor.vue?vue&type=script&lang=ts&"
export * from "./IconEditor.vue?vue&type=script&lang=ts&"
import style0 from "./IconEditor.vue?vue&type=style&index=0&id=3d73c6d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports